<template>
    <v-menu
        v-model="menuOpen"
        dense
        :offset-x="isOffsetX"
        :offset-y="isOffsetY"
        :open-on-hover="!isMobile && isOpenOnHover"
        :close-on-content-click="false"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-list-item
                dense
                v-if="icon"
                :color="color"
                v-bind="attrs"
                v-on="filteredOn(on)"
                @click.stop.prevent="handleParentClick"
                style="background: #1e1e1e"
            >
                <v-list-item-title dense
                    >{{ name }}<v-icon>{{ icon }}</v-icon></v-list-item-title
                >
            </v-list-item>
            <v-list-item dense v-else :color="color" v-bind="attrs" v-on="on">
                <v-list-item-title dense style="color: #2196f3">{{
                    name
                }}</v-list-item-title>
            </v-list-item>
        </template>
        <v-list
            dense
            style="max-height: 70vh; position: relative; z-index: 9999"
            @click.stop
        >
            <template v-for="(item, index) in menuItems">
                <v-divider v-if="1 == 2" :key="index" />
                <DanMenu
                    v-else-if="item.children"
                    :key="item.id"
                    :name="item.book_name"
                    :menu-items="item.children"
                    @dan-menu-click="handleChildClick"
                    :is-open-on-hover="true"
                    :icon="'mdi-menu-right'"
                    :is-offset-x="true"
                    :is-offset-y="false"
                    :is-sub-menu="true"
                />
                <v-list-item
                    dense
                    v-else
                    :key="item.book_name"
                    @click.stop.prevent="handleItemClick(item.book_name)"
                    style="background: #1e1e1e"
                >
                    <v-list-item-title dense>{{
                        item.book_name
                    }}</v-list-item-title>
                </v-list-item>
            </template>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: "DanMenu",
    props: {
        name: String,
        icon: String,
        menuItems: Array,
        color: { type: String, default: "primary" },
        isOffsetX: { type: Boolean, default: false },
        isOffsetY: { type: Boolean, default: true },
        isOpenOnHover: { type: Boolean, default: false },
        isSubMenu: { type: Boolean, default: false },
        transition: { type: String, default: "scale-transition" },
    },
    data() {
        return {
            menuOpen: false,
        };
    },
    computed: {
        isMobile() {
            return "ontouchstart" in window || navigator.maxTouchPoints > 0;
        },
    },
    methods: {
        filteredOn(on) {
            if (this.isMobile) {
                const { click, ...rest } = on;
                return rest;
            }
            return on;
        },
        emitClickEvent(item) {
            this.$emit("dan-menu-click", item);
        },
        handleParentClick() {
            if (this.isMobile) {
                if (this.menuOpen) {
                    this.menuOpen = false;
                    setTimeout(() => {
                        this.emitClickEvent(this.name);
                    }, 100);
                } else {
                    this.menuOpen = true;
                }
            } else {
                this.emitClickEvent(this.name);
            }
        },
        handleChildClick(itemName) {
            this.menuOpen = false;
            this.emitClickEvent(itemName);
        },
        handleItemClick(itemName) {
            this.emitClickEvent(itemName);
            this.menuOpen = false;
        },
    },
};
</script>
<style scoped>
::v-deep .v-menu__content {
    z-index: 9999 !important;
    pointer-events: auto;
}
</style>
